import { useGetRegioniQuery } from "../store/services/LookUpService"

export default function RegioniLookUp(isAll: boolean) {
    const { data } = useGetRegioniQuery('');

    const replaceEsito = (esito: string) => {
        let split = esito.split(/(?=[A-Z])/);
        return `${split[0]} ${split[1] ? split[1]?.toLowerCase() : ''}`
    }

    if (isAll) {
        let All = data?.map((esito: string) => (
            { value: esito, label: replaceEsito(esito) }
        ))

        return All
    } else {

        let optionEsito = data?.map((esito: string) => (
            { value: esito, label: replaceEsito(esito) }
        )).filter((esito: { value: string, label: string }) => {
            return esito?.value !== 'Tutte';
        });

        return optionEsito
    }

}

/**
 * Filtra le regioni dal lookup in base alle regioni di pertinenza
 * @param regioniPertinenza string[] - es. ['Veneto', 'Lombardia']
 * @param lookup { value: string; label: string }[]
 * @returns { value: string; label: string }[]
 */
export function filtraRegioni(regioniPertinenza: string[], lookup: { value: string; label: string }[]) {
  if (!Array.isArray(regioniPertinenza) || regioniPertinenza.length === 0) {
    return lookup; // se non ci sono restrizioni, ritorna tutte
  }

  return lookup.filter((regione) => regioniPertinenza.includes(regione.value));
}